import { render, staticRenderFns } from "./UploadModal.vue?vue&type=template&id=605ba129&scoped=true"
import script from "./UploadModal.vue?vue&type=script&lang=js"
export * from "./UploadModal.vue?vue&type=script&lang=js"
import style0 from "./UploadModal.vue?vue&type=style&index=0&id=605ba129&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605ba129",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('605ba129')) {
      api.createRecord('605ba129', component.options)
    } else {
      api.reload('605ba129', component.options)
    }
    module.hot.accept("./UploadModal.vue?vue&type=template&id=605ba129&scoped=true", function () {
      api.rerender('605ba129', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/UploadModal.vue"
export default component.exports